export default {
    fontFamily: 'Exo, Ariel, Helvetica, sans-serif'
}